import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { YourLumpSumAllowances } from 'src/app/model/ngrx/your-lump-sum-allowances.model';
 

export const ADD_YOUR_LUMP_SUM_ALLOWANCES = '[YOURLUMPSUMALLOWANCES] Add';
export const REMOVE_YOUR_LUMP_SUM_ALLOWANCES = '[YOURLUMPSUMALLOWANCES] Remove';

// AddPersonalDetails
export class AddYourLumpSumAllowances implements Action {
    readonly type = ADD_YOUR_LUMP_SUM_ALLOWANCES;

    constructor(public payload: YourLumpSumAllowances) { }
}
// RemovePersonalDetails
export class RemoveYourLumpSumAllowances implements Action {
    readonly type = REMOVE_YOUR_LUMP_SUM_ALLOWANCES;

    constructor(public payload: number) { }
}

export type Actions = AddYourLumpSumAllowances | RemoveYourLumpSumAllowances;